import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'

interface WGRangeSizeProps {
    value: number
    onChange: (value: number) => void
    step: number
    min: number
    max?: number
}
export const WidgetGalleryRangeSize = ({ value, onChange, step, min, max }: WGRangeSizeProps): JSX.Element => {
    return (
        <StyledWidgetGalleryRangeSize className={'StyledWGRangeSize'}>
            <input
                className={'StyledWGRangeSize__slider'}
                type={'range'}
                min={min.toString()}
                max={max?.toString()}
                step={step.toString()}
                value={value?.toString()}
                onChange={event => onChange(parseInt(event.target.value))}
            />
            <label className={'StyledWGRangeSize__currentValueLabel'}>
                {value}{' '}
                <>
                    {max && (
                        <span className={'StyledWGRangeSize__currentValueLabel--maxValueLabel'}>
                            / {max} {i18n('of total width')}
                        </span>
                    )}
                </>
            </label>
        </StyledWidgetGalleryRangeSize>
    )
}

const StyledWidgetGalleryRangeSize = styled.div`
    .StyledWGRangeSize {
        display: flex;
        flex-direction: column;
        width: auto;

        &__slider {
            appearance: none;
            width: 108px;
            height: 8px;
            opacity: 1;
            -webkit-transition: 0.3;
            -webkit-appearance: none;
            transition: 0.3s;
            &:hover {
                opacity: 0.8;
            }
            &::-moz-range-progress {
                background: #37a3ef;
                height: 8px;
                min-width: 1px;
                border-radius: 32px;
            }
            &::-moz-range-track {
                background-color: #c8ccd4;
                border-radius: 32px;
                height: 8px;
                border: none;
            }
            &::-moz-range-thumb {
                width: 20px;
                height: 20px;
                background: #37a3ef;
                border-radius: 50%;
                cursor: pointer;
                border: none;
                outline: none;
            }
            &::-webkit-slider-thumb {
                -webkit-appearance: none;
                width: 20px;
                height: 20px;
                background: #37a3ef;
                border-radius: 50%;
                cursor: pointer;
                border: none;
                outline: none;
                margin-top: -6px;
            }
            &::-webkit-slider-runnable-track {
                background: #62beff;
                border-radius: 32px;
                height: 8px;
                border: none;
            }
        }
        &__currentValueLabel {
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 16px;
            color: #364159;
            margin-top: 8px;
            &--maxValueLabel {
                color: #585858dd;
            }
        }
    }
`
